import type { JSTAccountStatusRecord, Spec } from "../../tare-spec/NativeJSTAccountStatus";

/** Native codegen module is unavailable on web. */
export function getNativeJSTAccountStatusModule(): Spec | undefined {
  return undefined;
}

export function getJSTAccountStatus(): JSTAccountStatusRecord | null {
  try {
    return {
      isLoggedIn: globalThis._tareData.isLoggedIn,
      id: globalThis._tareData.id,
      accountId: globalThis._tareData.accountId,
      emailAddress: globalThis._tareData.emailAddress,
      isConfirmed: globalThis._tareData.isConfirmed,
      creationDate: globalThis._tareData.creationDate,
    };
  } catch (error: unknown) {
    console.error(error);
    return null;
  }
}
